module.exports = __webpack_public_path__ + "img/show.2cff6ae4.svg";